import { createAction, props } from '@ngrx/store';

export const signInRequest = createAction(
  '[User] Sign In Request',
  props<{ email: string; password: string }>()
);

export const signInSuccess = createAction(
  '[User] Sign In Success',
  props<{ message: string, data: any }>()
);

export const signInFailure = createAction(
  '[User] Sign In Failure',
  props<{ message: string }>()
);

export const setDataRequest = createAction(
  '[User] Set Data Request'
);

export const setDataSuccess = createAction(
  '[User] Set Data Success',
  props<{ data: any }>()
);

export const setDataFailure = createAction(
  '[User] Set Data Failure',
  props<{ message: string }>()
);

export const getUserDataRequest = createAction(
  '[User] Get User Data Request'
);

export const getUserDataSuccess = createAction(
  '[User] Get User Data Success',
  props<{ data: any }>()
);

export const getUserDataFailure = createAction(
  '[User] Get User Data Failure',
  props<{ message: string }>()
);

export const logout = createAction(
  '[User] logout'
);
